// extracted by mini-css-extract-plugin
module.exports = {"container":"_7971133","inner":"_034df61","announcement":"_00e6a67","preview":"_60c2949","title":"_e188b6b","readMore":"_6064d68","close":"_45a842b","content":"_3796edf"};